import { REDUCE_VIEW } from '../../constants/actions/policies';

export function reduceView(payload) {
    return {
        type: REDUCE_VIEW,
        payload,
    };
}
